var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardDark = function SvgDashboardDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 1.875,
    d: "M9.303 4H5a1 1 0 0 0-1 1v4.303a1 1 0 0 0 1 1h4.303a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeMiterlimit: 10,
    strokeWidth: 1.875,
    d: "M19 4h-4.303a1 1 0 0 0-1 1v4.303a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM9.303 13.697H5a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1h4.303a1 1 0 0 0 1-1v-4.303a1 1 0 0 0-1-1ZM19 13.697h-4.303a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1H19a1 1 0 0 0 1-1v-4.303a1 1 0 0 0-1-1Z"
  })));
};
export default SvgDashboardDark;